import React from "react";
import { Link } from "react-router-dom";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-pink-50 to-blue-50 px-4 py-12 dark:bg-gray-900">
      <div className="mx-auto max-w-4xl rounded-xl bg-white/90 p-6 shadow-md backdrop-blur dark:bg-gray-800/90">
        <h1 className="mb-6 text-3xl font-bold text-gray-900 dark:text-white">
          Impressum
        </h1>

        <div className="space-y-4 text-gray-700 dark:text-gray-200">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Bitte die Platzhalter mit den korrekten Angaben ersetzen, damit das
            Impressum den gesetzlichen Anforderungen (u.a. § 5 TMG, § 18 Abs. 2
            MStV) entspricht.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Anbieter
            </h2>
            <p>
              Colin Frugte
              <br />
              Hartwig-Hesse-Straße 27
              <br />
              20257 Hamburg
              <br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Kontakt
            </h2>
            <p>
              {/* Telefon: <span className="font-mono">+49 (0) 000 000000</span>
              <br /> */}
              E-Mail: <span className="font-mono">help@jingolin.com</span>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Vertretungsberechtigte
            </h2>
            <p>Geschäftsführer / Inhaber: Colin Frugte</p>
          </section>

          {/* <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Registereintrag
            </h2>
            <p>
              Registergericht: Amtsgericht Hamburg<br />
              Registernummer: HRB 123456
            </p>
          </section> */}

          {/* <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Umsatzsteuer-ID
            </h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz: DE123456789
            </p>
          </section> */}

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Verantwortlich für den Inhalt
            </h2>
            <p>
              Verantwortlicher gem. § 18 Abs. 2 MStV: Colin Frugte, Anschrift
              wie oben.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              EU-Streitschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung bereit:{" "}
              <a
                className="text-rose-600 underline"
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noreferrer"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              . Wir sind nicht verpflichtet und nicht bereit, an einem
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>

          <p className="text-sm text-gray-500 dark:text-gray-400">
            Zurück zur{" "}
            <Link to="/" className="text-rose-600 underline">
              Startseite
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
